export default __webpack_public_path__ + "static/media/levenspad_NL_pc2.eb0e7d8b.png";